module.exports = __webpack_public_path__ + "img/companionship.19d95fdd.png";